import { AceClaimAction } from "./types";

export const createAceClaim = (payload) =>
  ({
    type: AceClaimAction.CREATE_CLAIM,
    payload,
  }) as const;

export const insertClaimItems = (payload) =>
  ({
    type: AceClaimAction.INSERT_CLAIM_ITEMS,
    payload,
  }) as const;

export const removeClaimItem = (payload) =>
  ({
    type: AceClaimAction.REMOVE_CLAIM_ITEM,
    payload,
  }) as const;

export const insertClaimItemDamages = (payload) =>
  ({
    type: AceClaimAction.INSERT_CLAIM_ITEM_DAMGES,
    payload,
  }) as const;

export const setWarrItems = (payload) =>
  ({
    type: AceClaimAction.SET_WARRNTY_ITEMS,
    payload,
  }) as const;

export const setClaimInfo = (payload) =>
  ({
    type: AceClaimAction.SET_CLAIM_INFO,
    payload,
  }) as const;

export const submitClaim = () =>
  ({
    type: AceClaimAction.SUBMIT_CLAIM,
  }) as const;

export const fetchAceClaimInfo = (payload) =>
  ({
    type: AceClaimAction.FETCH_CLAIM_INFO,
    payload,
  }) as const;

export const cleanUpClaimInfo = () =>
  ({
    type: AceClaimAction.CLEAN_UP,
  }) as const;

export const deleteClaimCreateNew = (payload) =>
  ({
    type: AceClaimAction.DELETE_CLAIM_CREATE_NEW,
    payload,
  }) as const;

export const handleClaimItemFileUpload = (payload) =>
  ({
    type: AceClaimAction.CLAIM_ITEM_FILE_UPLOAD,
    payload,
  }) as const;

export const removeClaimItemImage = (payload) =>
  ({
    type: AceClaimAction.CLAIM_ITEM_DELETE_IMAGE,
    payload,
  }) as const;

export const removeClaimItemDamage = (payload) =>
  ({
    type: AceClaimAction.DELETE_DAMAGE_ITEM,
    payload,
  }) as const;
